export default "__VITE_ASSET__BKJ2vGtf__"